import {Box, Typography} from "@mui/material";
import React from "react";
import {useLanguage} from "../../../LanguageContext";
import {titleBoxStyle, titleDateStyle, titleDetailsBoxStyle, titlePriceStile} from "../../styles/IntroSectionStyles";

export const IntoSection = ({context}) => {
    const {t} = useLanguage();

    return (
        <Box>
            <Box sx={titleBoxStyle}>
                <Typography
                    sx={{
                        fontSize: {
                            xs: '80px',
                            sm: '100px',
                            md: '120px',
                            lg: '150px',
                        },
                        letterSpacing: '0rem',
                        fontFamily: 'ButlerLight',
                    }}>
                    {t(context.title)}
                </Typography>
                <Typography
                    sx={{
                        marginTop: {
                            xs: '-20px',
                            md: '-45px',
                        },
                        fontSize: {
                            xs: '30px',
                            sm: '30px',
                            md: '30px',
                            lg: '30px',
                        },
                        letterSpacing: '0rem',
                        fontFamily: 'Jost-Regular',
                    }}>
                    {t(context.subtitle)}
                </Typography>
            </Box>

            <Box
                style={titleDetailsBoxStyle}>
                <Typography
                    sx={titleDateStyle}>
                    {t(context.date)}
                </Typography>
                <Typography
                    sx={titlePriceStile}>
                    {t('label_adv_cost')} {t(context.price)}
                </Typography>
            </Box>
        </Box>
    );
}
